import { useTranslation } from 'react-i18next'

import { useEmitter } from '@shared/lib/emitter'
import Button from '@shared/ui/button'

interface AddToCartProps {
  isTablet: boolean;
  className?: string;
  onClick?: () => void;
}

export default function AddToCart (props: AddToCartProps) {
  const { isTablet, className, onClick } = props
  const { t: tp } = useTranslation('product')
  const { emitter } = useEmitter()

  const handleClick = () => {
    emitter.emit('addCartProduct')

    if (onClick) {
      onClick()
    }
  }

  return (
    <Button
      className={className}
      type="submit"
      size={isTablet ? 'medium' : 'large'}
      theme="primary"
      onClick={handleClick}
    >
      {tp('in_cart.1')}
    </Button>
  )
}
